export default __webpack_public_path__ + "static/media/prize-4-cn.87b0980f.webp";